import { HTTP } from '@voicekey/api/http'
import { action, observable, makeObservable } from 'mobx'
import axios from 'axios'

export class DocumentationStore {
  constructor () {
    makeObservable(this, {
      _services: observable,
      getActiveServices: action
    })
  }

  _services = null

  get services () {
    return this._services
  }

  set services (value) {
    this._services = value
  }

  async getServices () {
    try {
      const response = await axios.get('./documentation.json')
      return response.data
    } catch (error) {
      return []
    }
  }

  async getActiveServices () {
    const services = await this.getServices()
    const activeServices = []
    for (const service of services) {
      const activeHosts = []
      for (const host of service.hosts) {
        const isActive = await this.checkService(host.path)
        if (isActive) activeHosts.push(host)
      }
      if (activeHosts.length) {
        activeServices.push({
          ...service,
          hosts: activeHosts
        })
      }
    }
    this.services = activeServices
  }

  async checkService (url) {
    try {
      await HTTP.get(url)
      return true
    } catch (error) {
      return false
    }
  }
}
